"use strict";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".search-block").forEach((searchBlock) => {
        const searchElement = searchBlock.querySelector(".search");
        const searchModule = searchBlock.querySelector(".search-module");

        if (!searchElement || !searchModule) return;

        let originalHeight = 0;

        const handleScroll = () => {
            const rect = searchElement.getBoundingClientRect();
            const triggerDistance = window.innerWidth > 768 ? 144 : 100;

            if (rect.top <= triggerDistance) {
                if (!searchModule.classList.contains("glue")) {
                    originalHeight = searchModule.offsetHeight;
                    searchElement.style.height = `${originalHeight}px`;
                    searchModule.classList.add("glue");
                }
            } else {
                if (searchModule.classList.contains("glue")) {
                    searchModule.classList.remove("glue");
                    searchElement.style.height = "";
                }
            }
        };

        window.addEventListener("scroll", handleScroll);

        window.addEventListener("resize", () => {
            if (!searchModule.classList.contains("glue")) {
                originalHeight = searchModule.offsetHeight;
            }
        });

        handleScroll();
    });
});